import Entity from "./Entity";

export default class User extends Entity {
    constructor(data) {
        super(data);
    }

    getId() {
        return this.get("id");
    }
    
    get phoneNumber() {
        return this.get("phoneNumber");
    }

    set phoneNumber(value) {
        this.set("phoneNumber", value);
    }

    get groupIds() {
        return this.get("groupIds");
    }

    isSuperAdmin() {
        const superAdmin = this.get("superadmin");
        if (superAdmin) {
            return superAdmin
        } else {
            return false;
        }
    }
}